module.exports = __webpack_public_path__ + "img/logo.acd289eb.svg";